module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Username"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.username),
      expression: "config.auth.username"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Password"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.password),
      expression: "config.auth.password"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.config.auth.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.config.auth.token) ? _c('form-group', {
    attrs: {
      "label": "Token",
      "columns": 6
    }
  }, [_vm._v("\n      " + _vm._s(_vm.config.auth.token.substring(0, 50)) + "...\n      "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.config.auth.token),
      expression: "config.auth.token",
      arg: "copy"
    }],
    staticClass: "btn btn--sm btn--info copy hint hint--top",
    attrs: {
      "type": "button",
      "data-label": "Clique para copiar"
    },
    on: {
      "click": function($event) {
        return _vm.copied()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])]) : _vm._e()], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('product-price-configuration', {
    attrs: {
      "input": _vm.config.product.price
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor de estoque padrão"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stock.reducer),
      expression: "config.product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.product.stock, "reducer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Webhook notificação de produto ",
      "columns": 6
    }
  }, [_vm._v("\n        " + _vm._s(_vm.urlWebhookProductNotification) + "\n\n        "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.urlWebhookProductNotification),
      expression: "urlWebhookProductNotification",
      arg: "copy"
    }],
    staticClass: "btn btn--sm btn--info copy hint hint--top",
    attrs: {
      "type": "button",
      "data-label": "Clique para copiar"
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Pedidos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Webhook notificação de pedidos ",
      "columns": 6
    }
  }, [_vm._v("\n        " + _vm._s(_vm.urlWebhookOrderNotification) + "\n\n        "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.urlWebhookOrderNotification),
      expression: "urlWebhookOrderNotification",
      arg: "copy"
    }],
    staticClass: "btn btn--sm btn--info copy hint hint--top",
    attrs: {
      "type": "button",
      "data-label": "Clique para copiar"
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('quotation.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('quotation-configuration', {
    attrs: {
      "quotation": _vm.config.quotation,
      "marketplace": _vm.identifier
    }
  })], 1)])]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('expediter-configuration', {
    attrs: {
      "expediter": _vm.config.order.expediter
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('order.label')
    }
  }, [_c('order-retrieve-date-configuration', {
    attrs: {
      "orderConfigs": _vm.config.order
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44f3863e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Renner.vue
// module id = 3106
// module chunks = 0